import Permission from './Permission';

export enum PermissionAction {
  SHOW_BUDGETS = 'SHOW_BUDGETS',
  SHOW_POINT_TRANSACTIONS = 'SHOW_POINT_TRANSACTIONS',
  SHOW_KAIZEN_MARKET = 'SHOW_KAIZEN_MARKET',
}

const AVAILABLE_PERMISSION_ACTION = Object.keys(PermissionAction);

class BfOrganization {
  public readonly kaizenUserId: string;
  public readonly permissions: Permission<PermissionAction>[];
  public readonly name: string;
  constructor({
    kaizenUserId,
    permissions,
    name,
  }: {
    kaizenUserId: string;
    permissions: Permission<PermissionAction>[];
    name: string;
  }) {
    this.kaizenUserId = kaizenUserId;
    this.permissions = permissions;
    this.name = name;
  }

  public hasPermission = (pa: PermissionAction) => {
    const pp = this.permissions.find((p: Permission<PermissionAction>) => p.action === pa);
    return pp && pp.permission;
  };

  public static fromJSON = (value: any) => {
    const { kaizen_user_id, permissions, name } = Object.assign({}, value);
    const kaizenUserId = String(kaizen_user_id);

    if (typeof kaizenUserId !== 'string') throw new TypeError('.kaizenUserId must be a string');
    if (typeof permissions !== 'object') throw new TypeError('.permissions must be an object');
    if (typeof name !== 'string') throw new TypeError('.name must be a string');

    return new BfOrganization({
      kaizenUserId,
      permissions: Object.keys(permissions).map((k: string) =>
        Permission.fromJSON(
          { action: k.toUpperCase(), permission: permissions[k].permit },
          AVAILABLE_PERMISSION_ACTION,
        ),
      ),
      name,
    });
  };
}

export default BfOrganization;
